'use strict';

(function() {
	angular.module('onboarding.common.settings')
		.directive('cobBrokerProfileSettings', cobBrokerProfileSettings, brokerSettingsService);

	cobBrokerProfileSettings.$inject = [
		'subjectObserverMessagesService', 'observerService', 'brokerSettingsService', 'sessionService'
	];

	var subjectObserverMessagesService,
		observerService,
		subjectMessages,
		observerMessages,
		brokerSettingsService,
		sessionService;

	function cobBrokerProfileSettings(_subjectObserverMessagesService_,
		_observerService_,
		_brokerSettingsService_,
		_sessionService_) {

		subjectObserverMessagesService = _subjectObserverMessagesService_;
		observerService = _observerService_;
		brokerSettingsService = _brokerSettingsService_;
		sessionService = _sessionService_;

		return {
			scope: {},
			templateUrl: '/app/common/settings/cobBrokerProfileSettings.html',
			replace: true,
			link: linkFunction
		};
	}

	function linkFunction(scope) {
		activate();

		function activate() {
			subjectMessages = subjectObserverMessagesService.getSubjectMessages();
			observerMessages = subjectObserverMessagesService.getObserverMessages();

			registerEventHandlers();

			scope.isVisible = false;
			scope.view = 'settings';
			scope.errors = {};
			scope.errors.errorMessage = '';
			scope.errors.errorMessageClass = 'message-error';
			scope.errors.messageType = '';
			scope.isDirty = false;

			scope.closeModal = closeModal;
			scope.toggleView = toggleView;
			scope.toggleSettings = toggleSettings;
			scope.onDirty = onDirty;
			scope.onClean = onClean;
			scope.modalClick = modalClick;

			scope.onSettingsOpen = onSettingsOpen;
			scope.isInternalAdmin = isInternalAdmin;
		}

		function registerEventHandlers() {
			observerService.registerHandlers(scope,
				[
					{ message: observerMessages.COB_OBSERVER_SETTINGS_BROKER_OPEN, handler: onSettingsOpen },
					{ message: observerMessages.COB_OBSERVER_PROFILE_SETTINGS_DIRTY, handler: onDirty },
					{ message: observerMessages.COB_OBSERVER_PROFILE_SETTINGS_CLEAN, handler: onClean },
					{ message: observerMessages.COB_OBSERVER_PROFILE_SETTINGS_CHANGE_VIEW, handler: onChangeView },
					{ message: observerMessages.COB_OBSERVER_PROFILE_SETTINGS_SAVE_VIEW, handler: onSaveView }
				]);
		}

		function isInternalAdmin() {
			return sessionService.isAuthorizedInternalAdmin();
		}

		function clickedOutsideModal() {
			observerService.sendMessageToSubject(
				scope,
				subjectObserverMessagesService.getSubjectMessages().COB_SUBJECT_PROFILE_SETTINGS_CHANGE_VIEW);
			if (!scope.isDirty) {
				scope.isVisible = false;
			}
		}

		function closeModal() {
			observerService.sendMessageToSubject(
				scope,
				subjectObserverMessagesService.getSubjectMessages().COB_SUBJECT_PROFILE_SETTINGS_CHANGE_VIEW);
			observerService.sendMessageToSubject(
				scope,
				subjectObserverMessagesService.getSubjectMessages().COB_SUBJECT_SETTINGS_BROKER_CLOSE);
			scope.isVisible = false;
		}

		function getSettings() {
			if (!scope.settings) {
				scope.settings = {};
			}

			brokerSettingsService.getBrokerSettings()
				.then(function(response) {
					scope.settings = response.data;
					scope.isDirty = false;
				})
				.catch(function(e) {
					console.log(e);
					// alert('Unable to retrieve carriers');
				});
		}

		function onSettingsOpen() {
			observerService.sendMessageToSubject(
				scope,
				subjectObserverMessagesService.getSubjectMessages().COB_SUBJECT_PROFILE_SETTINGS_CHANGE_VIEW);
			if (!scope.isDirty) {
				scope.isVisible = true;
				getSettings();
				toggleView('settings');
			}
		}

		function toggleView(selectedView) {
			scope.view = selectedView;
		}

		function toggleSettings(view) {
			scope.view = view;
		}

		function onDirty() {
			scope.isDirty = true;
		}

		function onClean() {
			scope.isDirty = false;
			scope.errors.errorMessage = '';
			scope.errors.errorMessageClass = 'message--error';
			scope.errors.messageType = '';
		}

		function onChangeView() {
			if (scope.isDirty) {
				scope.errors.errorMessage = 'Save or discard your changes.';
				scope.errors.errorMessageClass = 'message--error';
				scope.errors.messageType = 'error';
			} else
				scope.errors.errorMessage = '';
		}

		function onSaveView() {
			scope.errors.errorMessage = 'Changes saved';
			scope.isDirty = false;
			scope.errors.errorMessageClass = 'message--confirm';
			scope.errors.messageType = 'confirm';
		}

		function modalClick() {
			if (scope.errors.errorMessage) {
				onClean();
			}
		}
	}
})();
